import { Cronjob } from "../models/cronjob";

import BaseService from "./_base.service";

const ROUTE_NAME = "cronjobs";

const CronjobService = {
  ...BaseService<Cronjob>({ endpoint: ROUTE_NAME }),
};

export default CronjobService;
